<script>
  import conciliacaoProjetoServico from '../servico';
  import moment from 'moment';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  const DIAS_ALERTA_VIGENCIA = 60;

  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';
  import ConfiguracaoProjetoModal from './ConfiguracaoProjetoModal.vue';
  import permissoesConciliacao from '~js/permissoes-conciliacao';

  export default {
    components: { Paginacao, DatePicker, ConfiguracaoProjetoModal },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        registros: [],
        resumo: this.resumoVazio(),
        listaProjetos: [],
        listaResponsaveis: [],
        possuiRestricaoResponsavel: false,
        todos: false,
        carregando: true,
        animated: true,
        filtros: this.carregarFiltros(),
        timerFiltro: null,
        mostrarConfiguracao: false,
        mostrarProcessamento: false,
        carregandoPrevia: false,
        processando: false,
        previa: { pendentes: 0, incremental: false, restrito: false, dataCorte: '' },
        processados: 0,
        lancamentosLidos: 0,
        reprocessarTudo: false,
        exportando: false,
      }
    },
    computed: {
      podeAlterar() { return permissoesConciliacao.alterar('projeto'); },
      podeConfigurar() { return permissoesConciliacao.configurar('projeto'); },
      indice() { return (this.resumo.indiceConciliacao || 0).toString().replace('.', ','); },
      pctConciliadas() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.conciliadas / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctNaoConciliadas() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.naoConciliadas / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctEmConciliacao() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.emConciliacao / this.resumo.totalConciliacoes * 100) : 0;
      },
      pendentes() { return Math.max(0, (this.resumo.totalConciliacoes || 0) - (this.resumo.conciliadas || 0)); },
      temFiltro() {
        return this.filtros.status !== '0' || this.filtros.situacaoProjeto !== '0' || !!this.filtros.idResponsavel
            || !!this.filtros.vigenciaDe || !!this.filtros.vigenciaAte || !!this.filtros.idProjeto;
      },
      tituloSituacao() {
        if (this.filtros.situacaoProjeto === '1') return 'Projetos encerrados';
        if (this.filtros.situacaoProjeto === '2') return 'Ativos e encerrados';
        return 'Projetos ativos';
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Lista de Conciliação';

      const _this = this;
      $('#projetoFiltro').select2({ theme: 'bootstrap', placeholder: '🔍  Digite para buscar um projeto...', allowClear: true, language: 'pt-BR', minimumInputLength: 0 })
        .change(function () {
          _this.$set(_this.filtros, 'idProjeto', this.value || '');
          const projeto = _this.listaProjetos.filter(p => p.idProjetoCript === this.value)[0];
          _this.$set(_this.filtros, 'nomeProjeto', projeto ? projeto.nomeProjeto : '');
        });

      this.carregarProjetos();

      this.carregarResponsaveis();
    },
    methods: {
      resumoVazio() { return { totalConciliacoes: 0, conciliadas: 0, emConciliacao: 0, naoConciliadas: 0, indiceConciliacao: 0 }; },
      camposFiltros() { return { status: '0', situacaoProjeto: '0', idResponsavel: '', vigenciaDe: null, vigenciaAte: null, idProjeto: '', nomeProjeto: '', buscaProjeto: '' }; },
      filtrarStatus(status) { this.$set(this.filtros, 'status', this.filtros.status === status && status !== '0' ? '0' : status); },
      carregarFiltros() {
        try {
          const s = sessionStorage.getItem('conc-projeto-filtros');
          if (!s) return this.camposFiltros();
          const f = Object.assign(this.camposFiltros(), JSON.parse(s));
          if (f.vigenciaDe) f.vigenciaDe = new Date(f.vigenciaDe);
          if (f.vigenciaAte) f.vigenciaAte = new Date(f.vigenciaAte);
          return f;
        } catch (e) { return this.camposFiltros(); }
      },
      salvarFiltros() {
        try { sessionStorage.setItem('conc-projeto-filtros', JSON.stringify(this.filtros)); } catch (e) { }
      },
      montarFiltros() {
        return {
          status: this.filtros.status,
          situacaoProjeto: this.filtros.situacaoProjeto,
          idResponsavel: this.filtros.idResponsavel || 0,
          vigenciaDe: this.filtros.vigenciaDe ? moment(this.filtros.vigenciaDe).format('YYYY-MM-DD') : '',
          vigenciaAte: this.filtros.vigenciaAte ? moment(this.filtros.vigenciaAte).format('YYYY-MM-DD') : '',
          idProjeto: this.filtros.idProjeto || '',
          buscaProjeto: this.filtros.buscaProjeto || '',
        };
      },
      carregarProjetos() {
        return conciliacaoProjetoServico.projetos(this.todos, this.filtros.situacaoProjeto).then(p => { this.listaProjetos = p; });
      },
      sincronizarSelectProjeto() {
        const el = $('#projetoFiltro');
        if (!el.length) return;

        this.recuperarProjetoSalvo();

        el.val(this.filtros.idProjeto || '').trigger('change.select2');
      },
      recuperarProjetoSalvo() {
        const valor = this.filtros.idProjeto || '';
        if (!valor || this.listaProjetos.length === 0) return;
        if (this.listaProjetos.some(p => p.idProjetoCript === valor)) return;

        const projeto = this.listaProjetos.filter(p => p.nomeProjeto === this.filtros.nomeProjeto)[0];

        this.$set(this.filtros, 'idProjeto', projeto ? projeto.idProjetoCript : '');
        if (!projeto) this.$set(this.filtros, 'nomeProjeto', '');
      },
      carregarResponsaveis() {
        return conciliacaoProjetoServico.responsaveis()
          .then(r => { this.listaResponsaveis = r || []; })
          .catch(() => { this.listaResponsaveis = []; });
      },
      lista(pagina = 1) {
        this.carregando = true;
        this.registros = [];
        this.pagina = pagina;
        return conciliacaoProjetoServico.lista(pagina, this.montarFiltros(), this.todos)
          .then(dados => {
            this.carregando = false;
            this.registros = (dados.registros || []).slice().sort((a, b) => this.pendencias(b) - this.pendencias(a));
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;
            this.resumo = dados.resumo || this.resumoVazio();
            this.possuiRestricaoResponsavel = dados.possuiRestricaoResponsavel;
          })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar as conciliações.'); });
      },
      agendarLista() {
        clearTimeout(this.timerFiltro);
        this.timerFiltro = setTimeout(() => this.lista(1), 250);
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => this.sincronizarSelectProjeto());
        this.carregarProjetos();
        this.agendarLista();
      },
      alternarTodos() { this.todos = !this.todos; this.carregarProjetos(); this.limparFiltros(); },
      abrirConciliacao(projeto) {
        this.$router.push({ name: 'conciliacao-projeto.tela', params: { idProjetoCript: projeto.idProjetoCript } });
      },
      abrirProcessamento() {
        this.mostrarProcessamento = true;
        this.processados = 0;
        this.lancamentosLidos = 0;
        this.reprocessarTudo = false;
        this.carregarPrevia();
      },
      carregarPrevia() {
        this.carregandoPrevia = true;
        this.previa = { pendentes: 0, incremental: false, restrito: false, dataCorte: '' };
        conciliacaoProjetoServico.previaProcessamento(this.reprocessarTudo, this.todos)
          .then(dados => { this.previa = dados || this.previa; this.carregandoPrevia = false; })
          .catch(() => { this.carregandoPrevia = false; toastr.error('Não foi possível carregar os dados do processamento.'); });
      },
      alternarReprocessar() {
        if (this.processando) return;
        this.reprocessarTudo = !this.reprocessarTudo;
        this.carregarPrevia();
      },
      fecharProcessamento() {
        if (this.processando) return;
        this.mostrarProcessamento = false;
      },
      dataCorteTexto() {
        if (!this.previa.dataCorte) return 'sem data de corte — entra todo o histórico';
        return 'a partir de ' + moment(this.previa.dataCorte, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      processarProjetos() {
        if (this.processando) return;
        this.processando = true;
        this.processados = 0;
        this.lancamentosLidos = 0;
        this.processarLote(0);
      },
      processarLote(cursor) {
        conciliacaoProjetoServico.processarProjetos(cursor, this.reprocessarTudo, this.todos)
          .then(dados => {
            this.processados += (dados && dados.conciliados) || 0;
            this.lancamentosLidos += (dados && dados.lancamentos) || 0;

            if (dados && !dados.concluido) {
              this.processarLote(dados.cursor);
              return;
            }

            this.processando = false;
            this.mostrarProcessamento = false;
            if (this.processados > 0) toastr.success(this.processados.toLocaleString('pt-BR') + ' lançamento(s) conciliados automaticamente nos projetos.');
            else toastr.info('Nenhum lançamento novo para conciliar automaticamente.');
            this.lista(this.pagina);
          })
          .catch(res => {
            this.processando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível processar a conciliação automática.');
            if (this.processados > 0) this.lista(this.pagina);
          });
      },
      exportar() {
        if (this.exportando) return;
        this.exportando = true;

        conciliacaoProjetoServico.exportarLista(this.montarFiltros(), this.todos)
          .then(dados => {
            this.exportando = false;
            const registros = (dados && dados.registros) || [];

            if (registros.length === 0) { toastr.info('Nenhum projeto para exportar com os filtros atuais.'); return; }

            this.gerarCsv(registros);
          })
          .catch(() => { this.exportando = false; toastr.error('Não foi possível exportar a lista.'); });
      },
      gerarCsv(registros) {
        const cols = ['ID projeto', 'Projeto', 'Coordenador', 'Situação do projeto', 'Vigência início', 'Vigência fim',
          'Cor da vigência', 'Situação da vigência', 'Dias para o término',
          'Status', 'Lançamentos', 'Conciliados', 'Pendências', 'Conclusão (%)', 'Última atualização', 'Usuário'];
        const esc = v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"';

        const linhas = [cols.map(esc).join(';')];

        registros.forEach(r => {
          const vig = this.vigencia(r);

          linhas.push([
            r.idProjeto, r.nomeProjeto, r.coordenador, r.encerrado ? 'Encerrado' : 'Ativo',
            r.vigenciaInicio, r.vigenciaFim, vig.cor, vig.situacao, vig.dias == null ? '' : vig.dias,
            this.situacao(r).label,
            r.totalLancamentos, r.lancamentosConciliados, this.pendencias(r), r.percentualConclusao,
            r.ultimaAtualizacao, r.usuarioUltimaAtualizacao
          ].map(esc).join(';'));
        });

        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'lista-conciliacao-projetos-' + moment().format('DD-MM-YYYY') + '.csv';
        link.click();
        URL.revokeObjectURL(url);

        toastr.success(registros.length.toLocaleString('pt-BR') + ' projeto(s) exportados.');
      },
      abrirConfiguracao() { this.mostrarConfiguracao = true; },
      fecharConfiguracao() { this.mostrarConfiguracao = false; },
      aoSalvarConfiguracao() {
        this.mostrarConfiguracao = false;
        this.lista(this.pagina);
      },
      corProgresso(p) { return p >= 100 ? '#1ab394' : (p >= 50 ? '#f8ac59' : '#ed5565'); },
      situacao(r) {
        if (r.conciliado) return { label: 'Conciliado', cls: 'badge-ok', icon: 'fa-check' };
        if ((r.lancamentosConciliados || 0) > 0) return { label: 'Em conciliação', cls: 'badge-andamento', icon: 'fa-refresh' };
        return { label: 'Não conciliado', cls: 'badge-no', icon: 'fa-clock-o' };
      },
      vigencia(r) {
        if (r.encerrado)
          return { cls: 'vig-neutro', cor: 'Cinza', situacao: 'Projeto encerrado', label: 'Projeto já encerrado', dias: null };

        const fim = r.vigenciaFim ? moment(r.vigenciaFim, 'DD/MM/YYYY') : null;

        if (!fim || !fim.isValid())
          return { cls: 'vig-ok', cor: 'Verde', situacao: 'Sem data de término', label: 'Sem data de término: não há prazo para encerrar', dias: null };

        const dias = fim.startOf('day').diff(moment().startOf('day'), 'days');

        if (dias < 0)
          return { cls: 'vig-vencida', cor: 'Vermelho', situacao: 'Vigência vencida', label: 'Vigência vencida há ' + Math.abs(dias) + ' dia(s) — o projeto deveria estar encerrado', dias };

        if (dias <= DIAS_ALERTA_VIGENCIA)
          return { cls: 'vig-perto', cor: 'Amarelo', situacao: 'Termina em breve', label: dias === 0 ? 'Vigência termina hoje' : 'Vigência termina em ' + dias + ' dia(s)', dias };

        return { cls: 'vig-ok', cor: 'Verde', situacao: 'Dentro da vigência', label: 'Dentro da vigência · faltam ' + dias + ' dia(s)', dias };
      },
      podeAbrir(r) { return !r.encerrado || (r.lancamentosConciliados || 0) > 0; },
      pendencias(r) { return Math.max(0, (r.totalLancamentos || 0) - (r.lancamentosConciliados || 0)); },
      iniciou(r) { return (r.lancamentosConciliados || 0) > 0; },
      numero(v) { return (v || 0).toLocaleString('pt-BR'); },
      relativo(d) {
        if (!d) return '';
        const dt = moment(d, 'DD/MM/YYYY');
        if (!dt.isValid()) return '';
        const dias = moment().startOf('day').diff(dt.clone().startOf('day'), 'days');
        if (dias < 0) return '';
        if (dias === 0) return 'Hoje';
        if (dias === 1) return 'Ontem';
        if (dias < 30) return 'há ' + dias + ' dias';
        return '';
      },
    },
    created() { this.lista(this.pagina); },
    watch: {
      'filtros.status'() { this.agendarLista(); },
      'filtros.situacaoProjeto'() { this.carregarProjetos(); this.agendarLista(); },
      'filtros.idResponsavel'() { this.agendarLista(); },
      'filtros.vigenciaDe'() { this.agendarLista(); },
      'filtros.vigenciaAte'() { this.agendarLista(); },
      'filtros.idProjeto'() { this.agendarLista(); this.$nextTick(() => this.sincronizarSelectProjeto()); },
      listaProjetos() { this.$nextTick(() => this.sincronizarSelectProjeto()); },
      filtros: { deep: true, handler() { this.salvarFiltros(); } },
    },
  }
</script>

<template>
  <div>
  <div class="lst-page">
  <div :class="['lst-card', {'animated': animated}, $root.animacaoPadrao]">

    <div class="lst-topo">

    <div class="lst-head">
      <div>
        <div class="lst-tit">Lista de Conciliação</div>
        <div class="lst-res">
          {{ resumo.totalConciliacoes }} {{ resumo.totalConciliacoes === 1 ? 'projeto' : 'projetos' }} ·
          {{ resumo.conciliadas }} {{ resumo.conciliadas === 1 ? 'conciliado' : 'conciliados' }}
          <span v-if="pendentes > 0">· <span class="pend">{{ pendentes }} {{ pendentes === 1 ? 'pendente' : 'pendentes' }}</span> </span>· {{ indice }}% concluído
        </div>
      </div>
      <label class="lst-chk" v-if="possuiRestricaoResponsavel">
        <input type="checkbox" :checked="todos" @change="alternarTodos"> Mostrar todos os projetos
      </label>
    </div>

    <div class="kpi-faixa">
      <button type="button" class="kpi-card kpi-todas" :class="{ ativo: filtros.status === '0' }" @click="filtrarStatus('0')">
        <div class="kpi-lbl">{{ tituloSituacao }}</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.totalConciliacoes }}</span> <span class="kpi-qlf">no filtro atual</span></div>
      </button>
      <button type="button" class="kpi-card kpi-ok" :class="{ ativo: filtros.status === '1' }" @click="filtrarStatus('1')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Conciliados</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.conciliadas }}</span> <span class="kpi-qlf">{{ pctConciliadas }}% do total</span></div>
      </button>
      <button type="button" class="kpi-card kpi-andamento" :class="{ ativo: filtros.status === '3' }" @click="filtrarStatus('3')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Em conciliação</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.emConciliacao }}</span> <span class="kpi-qlf">{{ pctEmConciliacao }}% do total</span></div>
      </button>
      <button type="button" class="kpi-card kpi-nunca" :class="{ ativo: filtros.status === '2' }" @click="filtrarStatus('2')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Não conciliados</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.naoConciliadas }}</span> <span class="kpi-qlf">{{ pctNaoConciliadas }}% do total</span></div>
      </button>
    </div>

    <div class="ibox">
      <div class="ibox-title"><h5><i class="fa fa-filter"></i> Filtros</h5>
        <div class="ibox-tools">
          <button type="button" class="btn btn-xs" :class="temFiltro ? 'btn-warning' : 'btn-white'" :disabled="!temFiltro" @click="limparFiltros"><i class="fa fa-eraser"></i> Limpar filtros</button>
        </div>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="control-label">Buscar Projeto</label>
              <select id="projetoFiltro" class="form-control" v-model="filtros.idProjeto" style="width:100%">
                <option value=""></option>
                <option :value="p.idProjetoCript" v-for="p in listaProjetos" :key="p.idProjetoCript">{{ p.nomeProjeto }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="form-group">
              <label class="control-label">Situação do projeto</label>
              <div class="seg-situacao">
                <button type="button" :class="{ ativo: filtros.situacaoProjeto === '0' }" @click="filtros.situacaoProjeto = '0'">Ativos</button>
                <button type="button" :class="{ ativo: filtros.situacaoProjeto === '1' }" @click="filtros.situacaoProjeto = '1'">Encerrados</button>
                <button type="button" :class="{ ativo: filtros.situacaoProjeto === '2' }" @click="filtros.situacaoProjeto = '2'">Todos</button>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="form-group">
              <label class="control-label">Responsável pelo projeto</label>
              <select class="form-control" v-model="filtros.idResponsavel">
                <option value="">Todos os responsáveis</option>
                <option :value="r.idUsuario" v-for="r in listaResponsaveis" :key="r.idUsuario">{{ r.nomeUsuario }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="form-group">
              <label class="control-label">Vigência do projeto</label>
              <div class="f-vigencia">
                <date-picker v-model="filtros.vigenciaDe" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="dd/mm/aaaa" :editable="false" :shortcuts="false" :clearable="true"></date-picker>
                <span class="f-vigencia-ate">até</span>
                <date-picker v-model="filtros.vigenciaAte" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="dd/mm/aaaa" :editable="false" :shortcuts="false" :clearable="true"></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>

    <div class="ibox tabela-ibox lst-corpo">
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-hover tabela-conc">
            <thead>
              <tr>
                <th>Projeto</th>
                <th title="Verde: dentro da vigência · Amarelo: termina em até 60 dias · Vermelho: vigência vencida, o projeto deveria estar encerrado">Vigência</th>
                <th>Status</th>
                <th class="text-right">Pendências</th>
                <th style="min-width:200px">Conclusão</th>
                <th>Última atualização</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in registros" :key="r.idProjetoCript">
                <td class="col-projeto">{{ r.nomeProjeto }} <span v-if="r.encerrado" class="tag-encerrada">encerrado</span></td>
                <td class="small nowrap">
                  <template v-if="r.vigenciaInicio || r.vigenciaFim">
                    <div class="vig-linha" :title="vigencia(r).label">
                      <span class="vig-dot" :class="vigencia(r).cls"></span>
                      <span v-if="r.vigenciaInicio">{{ r.vigenciaInicio }}</span>
                      <span v-else class="vig-inf">∞</span>
                    </div>
                    <div class="text-muted vig-fim" :title="vigencia(r).label">
                      até <span v-if="r.vigenciaFim">{{ r.vigenciaFim }}</span>
                      <span v-else class="vig-inf">∞</span>
                    </div>
                  </template>
                  <span v-else class="text-muted"><em>Sem vigência</em></span>
                </td>
                <td>
                  <span class="badge-status" :class="situacao(r).cls"><i class="fa" :class="situacao(r).icon"></i> {{ situacao(r).label }}</span>
                </td>
                <td class="text-right">
                  <template v-if="iniciou(r)">
                    <div class="pendencias" :class="{ 'pend-zero': pendencias(r) === 0 }">{{ numero(pendencias(r)) }}</div>
                    <small class="text-muted">{{ pendencias(r) === 1 ? 'item' : 'itens' }}</small>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <template v-if="iniciou(r)">
                    <div class="barra-conc">
                      <span :style="{ width: r.percentualConclusao + '%', background: corProgresso(r.percentualConclusao) }"></span>
                    </div>
                    <div class="barra-legenda">
                      <span class="dot" :style="{ background: corProgresso(r.percentualConclusao) }"></span>
                      <strong :style="{ color: corProgresso(r.percentualConclusao) }">{{ r.percentualConclusao }}%</strong>
                      <span class="text-muted">· {{ numero(r.lancamentosConciliados) }} / {{ numero(r.totalLancamentos) }} itens</span>
                    </div>
                  </template>
                  <span v-else class="text-muted"><em>Não iniciada</em></span>
                </td>
                <td class="nowrap">
                  <div>{{ r.ultimaAtualizacao || '---' }}<span class="text-muted" v-if="relativo(r.ultimaAtualizacao)"> · {{ relativo(r.ultimaAtualizacao) }}</span></div>
                  <small class="text-muted col-usuario" v-if="r.usuarioUltimaAtualizacao" :title="'Última alteração feita por ' + r.usuarioUltimaAtualizacao">
                    <i class="fa fa-user-o"></i> {{ r.usuarioUltimaAtualizacao }}
                  </small>
                </td>
                <td class="text-right">
                  <button v-if="podeAbrir(r)" type="button" class="btn btn-abrir" :class="r.encerrado ? 'btn-white btn-consulta' : 'btn-primary'"
                          :title="r.encerrado ? 'Projeto encerrado: a conciliação abre apenas para consulta' : ''" @click="abrirConciliacao(r)">
                    {{ r.encerrado ? 'Ver conciliação' : 'Abrir conciliação' }} <i class="fa fa-arrow-right"></i>
                  </button>
                  <span v-else class="text-muted small">Encerrado, sem conciliação</span>
                </td>
              </tr>
              <tr v-show="carregando"><td colspan="7" class="text-center text-muted" style="padding:24px"><i class="fa fa-spinner fa-pulse fa-2x"></i><div class="m-t-xs">Carregando...</div></td></tr>
              <tr v-show="!carregando && registros.length === 0"><td colspan="7" class="text-center text-muted" style="padding:24px">Nenhum projeto encontrado.</td></tr>
            </tbody>
          </table>
        </div>

        <paginacao v-if="totalPaginas > 1" :page-count="totalPaginas" :click-handler="lista" :per-page="registrosPorPagina" :register-count="totalRegistros" :show-counter="true"></paginacao>
        <div v-else-if="!carregando && totalRegistros > 0" class="text-muted small m-t-sm">Mostrando {{ totalRegistros }} registro(s)</div>
      </div>
    </div>

    <div class="acoes-rodape">
      <div>
        <button v-if="podeConfigurar" type="button" class="btn btn-white" @click="abrirConfiguracao"><i class="fa fa-cog"></i> Configurações</button>
      </div>
      <div class="acoes-rodape-r">
        <button type="button" class="btn btn-white" :disabled="exportando || carregando" @click="exportar"
                title="Exporta todos os projetos da lista com os filtros atuais, não só a página exibida">
          <i class="fa" :class="exportando ? 'fa-spinner fa-pulse' : 'fa-table'"></i> {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
        </button>
        <button v-if="podeAlterar" type="button" class="btn btn-primary" :disabled="processando" @click="abrirProcessamento"
                title="Aproveita as conciliações já feitas no banco e concilia automaticamente os lançamentos de todos os projetos">
          <i class="fa" :class="processando ? 'fa-spinner fa-pulse' : 'fa-magic'"></i>
          {{ processando ? 'Processando...' : 'Processar todos os projetos' }}
        </button>
      </div>
    </div>

  </div>
  </div>

    <configuracao-projeto-modal v-if="mostrarConfiguracao" @fechar="fecharConfiguracao" @salvo="aoSalvarConfiguracao"></configuracao-projeto-modal>

    <div v-if="mostrarProcessamento" class="conc-ov">
      <div class="conc-modal proc-modal">
        <div class="proc-head">
          <h4>Processar conciliação de todos os projetos</h4>
          <small class="proc-sub">Aproveita o que já foi conciliado no banco: cada lançamento conferido cujos rateios do projeto fecham com o valor é conciliado automaticamente.</small>
        </div>

        <div class="proc-corpo">
          <div v-if="carregandoPrevia" class="proc-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
          <template v-else>
            <div class="proc-cards">
              <div class="proc-card">
                <div class="proc-lbl">Lançamentos a verificar</div>
                <div class="proc-num">{{ numero(previa.pendentes) }}</div>
                <div class="proc-obs">{{ previa.incremental ? 'só o que entrou desde o último processamento' : 'todo o histórico dentro do período' }}</div>
              </div>
              <div class="proc-card">
                <div class="proc-lbl">Período considerado</div>
                <div class="proc-txt">{{ dataCorteTexto() }}</div>
                <div class="proc-obs" v-if="previa.restrito">só os projetos em que você é responsável</div>
                <div class="proc-obs" v-else-if="todos">todos os projetos, incluindo os de outros responsáveis</div>
              </div>
            </div>

            <label class="proc-check" v-if="previa.incremental || reprocessarTudo">
              <input type="checkbox" :checked="reprocessarTudo" :disabled="processando" @change="alternarReprocessar">
              Reverificar todo o histórico (mais demorado; use quando houver baixas antigas feitas no Desktop)
            </label>

            <div v-if="!previa.dataCorte && previa.pendentes > 0" class="proc-alerta">
              Sem data de corte, o processamento vai percorrer todo o histórico de uma vez.
              Se a intenção é começar de um período, feche esta janela e defina a data de corte em Configurações.
            </div>

            <div v-if="processando" class="proc-progresso">
              <i class="fa fa-spinner fa-pulse"></i>
              {{ numero(processados) }} lançamento(s) conciliados ·
              {{ numero(lancamentosLidos) }} de {{ numero(previa.pendentes) }} verificados. Deixe esta janela aberta.
            </div>
          </template>
        </div>

        <div class="proc-foot">
          <button type="button" class="btn btn-primary" :disabled="processando || carregandoPrevia || previa.pendentes === 0" @click="processarProjetos">
            <i class="fa" :class="processando ? 'fa-spinner fa-pulse' : 'fa-magic'"></i> {{ processando ? 'Processando...' : 'Processar' }}
          </button>
          <button type="button" class="btn btn-sair" :disabled="processando" @click="fecharProcessamento"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
  .kpi-faixa { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; padding: 12px 16px; }
  .kpi-card {
    text-align: left; padding: 10px 13px; background: #fff; border: 1px solid #e6e9ed; border-radius: 7px;
    transition: border-color .12s, background .12s;
  }
  .kpi-card:hover { border-color: #c6ccd4; }
  .kpi-lbl { display: flex; align-items: center; gap: 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .kpi-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
  .kpi-val { margin-top: 4px; }
  .kpi-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; font-size: 21px; font-weight: 600; color: #1c2024; }
  .kpi-qlf { font-size: 11.5px; color: #8a939c; margin-left: 5px; }

  .kpi-ok .kpi-lbl, .kpi-ok .kpi-num { color: #0a6d4d; }
  .kpi-andamento .kpi-lbl, .kpi-andamento .kpi-num { color: #c98a00; }
  .kpi-nunca .kpi-lbl, .kpi-nunca .kpi-num { color: #a13c3c; }

  .kpi-card.ativo { border-color: #a9b2bb; background: #f7f9fa; box-shadow: inset 0 0 0 1px #a9b2bb; }
  .kpi-ok.ativo { border-color: #0f8a5f; background: #f4faf7; box-shadow: inset 0 0 0 1px #0f8a5f; }
  .kpi-andamento.ativo { border-color: #c98a00; background: #fdf9ef; box-shadow: inset 0 0 0 1px #c98a00; }
  .kpi-nunca.ativo { border-color: #c98080; background: #fdf7f7; box-shadow: inset 0 0 0 1px #c98080; }

  .lst-page { box-sizing: border-box; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: #eceef1; padding: 12px 14px; overflow: auto; }
  .lst-card { min-width: 1080px; height: 100%; display: flex; flex-direction: column; background: #fff; border: 1px solid #d3d8de; border-radius: 8px; box-shadow: 0 1px 2px rgba(16,24,40,.06); overflow: hidden; }
  .lst-topo { flex: 0 0 auto; padding: 0 0 0; }
  .lst-head { display: flex; justify-content: space-between; align-items: flex-start; padding: 11px 16px 9px; border-bottom: 1px solid #eef1f4; }
  .lst-tit { font-size: 13.5px; font-weight: 600; color: #1c2024; }
  .lst-res { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 12px; color: #6b747e; margin-top: 2px; }
  .lst-res .pend { color: #c98a00; }
  .lst-chk { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: normal; color: #3b444d; margin: 0; cursor: pointer; padding: 5px 10px; border: 1px solid #dfe3e8; border-radius: 5px; }
  .lst-chk input { width: 13px; height: 13px; margin: 0; }
  .lst-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; margin: 0; border: none; box-shadow: none; }
  .lst-topo .ibox { border: none; box-shadow: none; margin-bottom: 10px; }
  .lst-corpo .ibox-content { border: none; padding-top: 0; }

  .acoes-rodape {
    flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; gap: 12px;
    padding: 12px 18px; background: #f7f9fa; border-top: 1px solid #dfe3e8;
  }
  .acoes-rodape-r { display: flex; align-items: center; gap: 8px; }

  .tabela-ibox { margin-top: -16px; }
  .tabela-conc { margin-bottom: 0; }
  .tabela-conc thead th {
    position: sticky; top: 0; z-index: 2;
    background: #f7f9fa; color: #7b848e; font-weight: 600; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em;
    border-bottom: 1px solid #dfe3e8 !important; border-top: none; padding: 8px 9px; white-space: nowrap;
  }
  .tabela-conc tbody td { vertical-align: middle; padding: 9px 8px; border-top: 1px solid #f0f1f3; }
  .tabela-conc tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .tabela-conc tbody tr:hover > td { background: #eaf5ff !important; }
  .tabela-conc .nowrap { white-space: nowrap; }
  .tabela-conc .col-projeto { font-weight: 600; color: #1a2035; }
  .tabela-conc .col-usuario { display: inline-block; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; }

  .f-vigencia { display: flex; align-items: center; gap: 8px; }
  .f-vigencia-ate { flex: 0 0 auto; font-size: 12.5px; color: #8a939c; }
  .vig-inf { font-size: 14px; line-height: 1; color: #9aa3ac; vertical-align: -1px; }
  .vig-linha { display: flex; align-items: center; gap: 6px; }
  .vig-fim { padding-left: 14px; }
  .vig-dot { flex: 0 0 auto; width: 8px; height: 8px; border-radius: 50%; }
  .vig-ok { background: #18a689; }
  .vig-perto { background: #f8ac59; }
  .vig-vencida { background: #ed5565; }
  .vig-neutro { background: #c6ccd4; }

  .seg-situacao { display: flex; width: 100%; border: 1px solid #c7cdd4; border-radius: 5px; overflow: hidden; height: 34px; }
  .seg-situacao button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 13px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .seg-situacao button:first-child { border-left: none; }
  .seg-situacao button:hover { background: #f4f6f8; }
  .seg-situacao button.ativo { background: #1ab394; color: #fff; font-weight: 600; }

  .badge-status { display: inline-flex; align-items: center; gap: 6px; padding: 6px 13px; border-radius: 14px; font-size: 12px; font-weight: 600; line-height: 1; }
  .badge-ok { background: #e5f7f0; color: #18a689; }
  .badge-andamento { background: #fff4e0; color: #d68a00; }
  .badge-no { background: #fdecec; color: #e05a5a; }

  .pendencias { font-size: 16px; font-weight: 700; color: #34495e; line-height: 1.1; }
  .pendencias.pend-zero { color: #b3b9c0; font-weight: 500; }

  .barra-conc { height: 14px; border-radius: 7px; background: #eceef1; overflow: hidden; }
  .barra-conc > span { display: block; height: 100%; border-radius: 7px; transition: width .3s; }
  .barra-legenda { margin-top: 5px; font-size: 12px; }
  .barra-legenda .dot { display: inline-block; width: 9px; height: 9px; border-radius: 50%; margin-right: 5px; vertical-align: middle; }
  .barra-legenda strong { font-size: 13px; }

  .conc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.52); z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 22px; }
  .conc-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); }
  .proc-modal { width: 620px; max-width: 100%; display: flex; flex-direction: column; overflow: hidden; }
  .proc-head { padding: 16px 20px; border-bottom: 1px solid #e6e9ed; }
  .proc-head h4 { margin: 0; font-size: 15.5px; font-weight: 600; color: #1c2024; }
  .proc-sub { display: block; font-size: 12.5px; color: #6b747e; margin-top: 4px; line-height: 1.5; }
  .proc-corpo { padding: 18px 20px; min-height: 140px; }
  .proc-carregando { text-align: center; color: #8a939c; padding: 30px 0; }
  .proc-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .proc-card { padding: 12px 14px; border: 1px solid #e6e9ed; border-radius: 7px; background: #fbfcfd; }
  .proc-lbl { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .proc-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 24px; font-weight: 600; color: #1c2024; margin-top: 4px; }
  .proc-txt { font-size: 13px; color: #3b444d; margin-top: 8px; }
  .proc-obs { font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .proc-check { display: flex; align-items: flex-start; gap: 8px; margin-top: 14px; font-size: 12.5px; font-weight: normal; color: #3b444d; cursor: pointer; }
  .proc-check input { margin: 2px 0 0; }
  .proc-alerta { margin-top: 14px; background: #fff8e6; border: 1px solid #f0dfae; border-radius: 5px; padding: 10px 12px; font-size: 12.5px; color: #8a6d1f; line-height: 1.5; }
  .proc-progresso { margin-top: 14px; font-size: 12.5px; color: #0a6d4d; background: #f4faf7; border: 1px solid #cbe9dc; border-radius: 5px; padding: 10px 12px; }
  .proc-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 13px 20px; background: #fafbfc; border-top: 1px solid #e6e9ed; }
  .btn-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .btn-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }

  .tag-encerrada { display: inline-block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: #c0392b; background: #fdecec; border: 1px solid #f5c6c6; border-radius: 10px; padding: 1px 8px; margin-left: 6px; vertical-align: middle; }

  .btn-abrir { font-weight: 600; padding: 7px 16px; border-radius: 4px; }
  .btn-consulta { color: #5b6570; border-color: #c6ccd4; }

  .btn-abrir .fa { margin-left: 4px; transition: transform .15s; }
  .btn-abrir:hover .fa { transform: translateX(3px); }
</style>

<style>
  .lst-card .f-vigencia .mx-datepicker { flex: 1 1 0; min-width: 0; width: auto !important; }
  .lst-card .f-vigencia .mx-datepicker .mx-input-wrapper, .lst-card .f-vigencia .mx-datepicker input { width: 100%; }
  .lst-card .f-vigencia .mx-input { height: 34px; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ConciliacaoLista.vue